/**
 * DevPersonaBar - admin-only testing strip shown above the dashboard.
 * Switches the dashboard's data between mock customer personas so admins can
 * preview how each customer type sees the page. Never rendered for customers.
 */

import React from "react";
import { Box, Chip, Typography } from "@mui/material";
import ScienceIcon from "@mui/icons-material/Science";

import { PERSONAS, type PersonaKey } from "../utils/personaPreview";
import { QUIZ } from "@/theme/quizTokens";

export function DevPersonaBar({
  value,
  onChange,
}: {
  value: PersonaKey;
  onChange: (key: PersonaKey) => void;
}) {
  return (
    <Box
      sx={{
        background: QUIZ.color.warmWhite,
        border: "1px dashed rgba(74, 48, 38, 0.35)",
        borderRadius: "12px",
        px: 2,
        py: 1.5,
        mb: 3,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, flexShrink: 0 }}>
        <ScienceIcon sx={{ fontSize: 18, color: QUIZ.color.brown }} />
        <Typography sx={{ fontSize: 13, fontWeight: 700, color: QUIZ.color.brown }}>
          Testing view
        </Typography>
      </Box>
      <Box sx={{ display: "flex", gap: 0.75, flexWrap: "wrap" }}>
        {PERSONAS.map((p) => {
          const selected = value === p.key;
          return (
            <Chip
              key={p.key}
              label={p.label}
              size="small"
              onClick={() => onChange(p.key)}
              sx={{
                fontWeight: 700,
                fontSize: 12,
                cursor: "pointer",
                background: selected ? QUIZ.color.blue : "transparent",
                color: selected ? QUIZ.color.ink : QUIZ.color.grey,
                border: selected
                  ? "1px solid transparent"
                  : "1px solid rgba(74, 48, 38, 0.25)",
                "&:hover": {
                  background: selected ? QUIZ.color.blue : QUIZ.color.cream,
                },
              }}
            />
          );
        })}
      </Box>
    </Box>
  );
}
